import { request } from "../request";

export const getDeviPosts = () =>
    request({
        url: "/devi",
        method: "GET",
    });

export const getTariffPrices = (language: string) =>
    request({
        url: "/devi/tariff_prices",
        method: "GET",
        options: {
            "Accept-Language": language,
        },
    });

export const getSubscriptionInfo = () =>
    request({
        url: "devi/info",
        method: "GET",
    });
